import { DatePicker } from "antd"
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns"

// This is a workaround for using the antd DatePicker without needing to add dayjs as a dependency
export const DateFnsDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig)
